import { Candidate, Contest, MunicipalCandidate, ProvincialCandidate } from "../types";
import { collection, getDocs, orderBy, query, where } from "firebase/firestore";

import { db } from "../firebase";

const listContests = (candidates: Candidate[]): Contest[] => {
  const _contests: Contest[] = [];
  for (const candidate of candidates) {
    const contest = _contests.find((c) => c.position === candidate.position);
    if (contest) {
      contest.candidates.push(candidate);
      contest.candidates.sort((a, b) => a.name.localeCompare(b.name));
    } else {
      _contests.push({
        position: candidate.position,
        candidates: [candidate]
      });
    }
  }
  return _contests;
}

export const fetchProvincialCandidates = async (province: string): Promise<Contest[]> => {
  const candidatesRef = collection(db, "candidates");
  const q = query(candidatesRef, 
    where("type", "==", "provincial"),
    where("province", "==", province),
    orderBy("position", "asc")
  );
  const querySnapshot = await getDocs(q);
  const candidates = querySnapshot.docs.map(doc => doc.data() as ProvincialCandidate);
  return listContests(candidates);
};

export const fetchMunicipalCandidates = async (province: string, city_municipality: string): Promise<Contest[]> => {
  const candidatesRef = collection(db, "candidates");
  const q = query(candidatesRef, 
    where("type", "==", "municipal"),
    where("province", "==", province),
    where("city_municipality", "==", city_municipality),
    orderBy("position", "asc")
  );
  const querySnapshot = await getDocs(q);
  const candidates = querySnapshot.docs.map(doc => doc.data() as MunicipalCandidate);
  return listContests(candidates);
};

export const fetchAllCandidates = async (): Promise<Candidate[]> => {
  const candidatesRef = collection(db, "candidates");
  const q = query(candidatesRef, orderBy("position", "asc"));
  const querySnapshot = await getDocs(q);
  return querySnapshot.docs.map(doc => doc.data() as Candidate);
};
